module.exports = __webpack_public_path__ + "media/page-3.38bf53da.mp3";